import { DateTime } from "luxon"
import { getMinimumEngagementStartDate } from "@oysterhr/hiring/full-time-employee"
import { convertUTCToLocalDate } from "@oysterhr/common"

// TEMP: This is a list of countries that won't be hiring during summertime and should have a start date
// starting in September 2nd as requested in this epic: https://oysterhr.kanbanize.com/ctrl_board/5/cards/31090/details/
const SUMMER_RESTRICTED_HIRING_COUNTRIES = ["IT", "FR"]

// Restriction starts in July 26th
export const INITIAL_SUMMER_RESTRICTION_DATE = DateTime.fromISO("2024-07-26")
// Restriction ends in August 24th
export const END_SUMMER_RESTRICTION_DATE = DateTime.fromISO("2024-08-24")

/**
 * Returns calculated engagement start date considering constraints along the year
 * @param countryCode the country ISO code
 * @returns Calculated minimum engagement start date. This will be the final value used in the DatePicker.
 */
export const getCalculatedMinEngagementStartDate = (countryCode: string = "") => {
  const currentDate = DateTime.now()

  // During summer freeze the initial start date must be September 2nd for the listed countries
  if (SUMMER_RESTRICTED_HIRING_COUNTRIES.includes(countryCode)) {
    if (
      currentDate >= INITIAL_SUMMER_RESTRICTION_DATE &&
      currentDate <= END_SUMMER_RESTRICTION_DATE
    ) {
      // Convert to local date to avoid errors with validation due to timezone difference
      const date = DateTime.utc(2024, 9, 2).toJSDate()
      return convertUTCToLocalDate(date)
    }
  }
  return getMinimumEngagementStartDate(countryCode)
}
